import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Button, Table, Loader } from '@itds/elements/index.js';

import EditDrawer from './etickets/Edit';

import { ACTION_MESSAGES } from '@carrier/utils/custom_hooks/useNotification';
import { CarrierContext } from '@carrier/contexts/CarrierContext';

import Api from '@carrier/utils/Api';

const EmbeddableEtickets = ({ relationship }) => {
  const navigate = useNavigate();
  const { setNotification } = useContext(CarrierContext);

  const [embeddable_etickets, setEmbeddableEtickets] = useState([]);
  const [loading, setLoading] = useState(true);
  const [eticket, setEticket] = useState();

  useEffect(() => {
    loadEmbeddableEtickets();
  }, []);

  const loadEmbeddableEtickets = () => {
    setLoading(true);

    Api.loadEmbeddableEtickets({
      vendor_id: relationship.vendor_id,
      carrier_id: relationship.carrier_id
    }).then(({ data }) => {
      setEmbeddableEtickets(data);
      setLoading(false);
    });
  };

  const handleSave = () => {
    setEticket(null);
    loadEmbeddableEtickets();
  };

  const toggleDeactivate = (eticket, e) => {
    e.stopPropagation();

    Api.saveEmbeddableEticket(eticket.id, {
      ...eticket,
      is_deactivated: !eticket.is_deactivated
    }).then(() => {
      loadEmbeddableEtickets();
      setNotification(
        ACTION_MESSAGES.CARRIERS.VENDOR.EMBEDDABLE_ETICKETS.DEACTIVATED(!eticket.is_deactivated)
      );
    });
  };

  return loading ? (
    <Loader />
  ) : (
    <>
      <EditDrawer
        eticket={eticket}
        onClose={setEticket.bind(null, null)}
        onSave={handleSave}
        relationship={relationship}
        show={!!eticket}
      />

      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: 30 }}>
        <Button onClick={setEticket.bind(null, { name: '' })}>New Embeddable E-Ticket</Button>
      </div>

      <Table
        columns={[
          {
            id: 'name',
            label: 'Name',
            width: 400
          },
          {
            id: 'id',
            label: 'ID'
          },
          {
            id: 'actions',
            render: eticket => {
              return (
                <div style={{ display: 'flex' }}>
                  <Button
                    color={'PRIMARY'}
                    inline={true}
                    onClick={navigate.bind(null, `${eticket.id}/preview`, {
                      state: { eticket }
                    })}
                    small={true}
                    style={{ marginRight: '5px' }}
                  >
                    Preview
                  </Button>
                  <Button
                    color={eticket.is_deactivated ? 'PRIMARY' : 'RED'}
                    onClick={toggleDeactivate.bind(null, eticket)}
                    small={true}
                  >
                    {eticket.is_deactivated ? 'Activate' : 'Deactivate'}
                  </Button>
                </div>
              );
            },
            styles: { textAlign: 'right' },
            width: 100
          }
        ]}
        data={embeddable_etickets}
        onRowClick={setEticket}
        placeholder='No Embeddable E-Tickets Yet'
      />
    </>
  );
};

EmbeddableEtickets.propTypes = {
  relationship: PropTypes.object,
  saveRelationship: PropTypes.func
};

export default EmbeddableEtickets;
